import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight, Loader2 } from "lucide-react";

export default function DemoLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/demo/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6" data-testid="demo-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-cyan-500/20">
            <Lock className="w-7 h-7 text-cyan-400" />
          </div>
          <h1 className="text-3xl font-bold text-white tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Demand Forecasting
          </h1>
          <p className="text-slate-400 text-sm mt-2">Pharma Supply Chain Intelligence Platform</p>
          <p className="text-xs text-slate-600 mt-1">Powered by BharatIntelliAI</p>
        </div>

        <form onSubmit={handleSubmit} className="glass-card rounded-2xl p-8 space-y-5" data-testid="demo-login-form">
          <div>
            <label className="text-xs font-medium text-slate-400 mb-1.5 block">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 rounded-lg px-4 py-3 text-sm text-slate-200 placeholder-slate-600 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all"
              placeholder="Enter your email"
              data-testid="demo-login-email"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-400 mb-1.5 block">Password</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 rounded-lg px-4 py-3 text-sm text-slate-200 placeholder-slate-600 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all"
              placeholder="Enter your password"
              data-testid="demo-login-password"
            />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="demo-login-error">{error}</p>}
          <button
            type="submit" disabled={loading}
            className="w-full bg-cyan-500 text-slate-950 py-3 rounded-full font-bold hover:bg-cyan-400 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="demo-login-submit"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <><span>Access Dashboard</span><ArrowRight size={16} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
